import styled from 'styled-components';
import { themes, images } from '../../assets';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background-image: url('loginBackground.svg');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 103%;
  align-items: center;
  margin: auto auto 0px auto;
  justify-content: space-evenly;

  @media (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    flex-direction: column;
    background-image: url('loginBackground.svg');
    background-repeat: no-repeat;
    background-position: bottom;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    background-image: none;
  }
`;

export const Column = styled.div`
  display: flex;
  align-items: center; 
  justify-content: space-evenly;
  position: absolute;
  flex-direction: line;
  background-color: white;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet}){
    height: 100%; 
  }

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}){
    flex-direction: column;
  }
  
  @media (max-height: 900px) {
    height: 900px;
  }
`;

export const ContentContainer = styled.div`
  background-image: ${images.FundoForm};
  position: relative;
  top: 90px;
  left: 241px;
  align-items: center;
  margin: auto auto 0px auto;
  justify-content: space-evenly;

  @media (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    flex-direction: column;
    top: 90px;
    left: 220px;
    background-image: ${images.FundoForm};
  }

  @media (max-width: 600px) {
    flex-direction: column;
    background-image: none;
    align-items: baseline;
    /* Neutraliza o offset absoluto do layout desktop (que empurra o
       form pra fora da tela no mobile). */
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
  }
`;

export const Icon = styled.img`
  width: 67%;
  height: ${(props) => props.height};
  ${(props) => props.margin && `margin: ${props.margin}`}

  @media (max-width: 600px) {
    background-image: none;
  }
`;

export const Title = styled.label`
  font-size: clamp(22px, 4vw, 30px);
  font-weight: 900;
  margin: 80px 0 0 0;
  color: ${themes.darkblue};
  position: relative;
  bottom: 470px;
  right: 49%;

  @media (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    position: relative;
    bottom: 470px;
    right: 51%;
  }

  /* No mobile o offset absoluto nao faz sentido (form em fluxo
     normal) — reseta pra posicao estatica. */
  @media (max-width: 600px) {
    position: static;
    bottom: auto;
    right: auto;
    margin: 16px 0 8px;
  }
`;


export const Cmodel = styled.form`
  width: min(450px, 92vw);
  align-items: center;
  justify-content: space-evenly;

  .floater {
    padding: "5px 15px";
    border-radius: 4;
    font-size: 12;
    min-height: 'unset';
    min-width: 'unset';
    display: 'flex';
    align-items: 'center';
    justify-content: 'center';
    transition: "0.2s";
  }
`;

export const Label = styled.label`
  font-size: ${(props) => props.size};
  color: #192b80;
  ${(props) => props.bold && 'font-weight: bold'}
  ${(props) => props.pointer && 'cursor: pointer'};
  ${(props) => props.hover && ':hover {text-decoration: underline}'}
  ${(props) => props.margin && `margin: ${props.margin}`}
`;

export const ButtonContainer = styled.div`
  justify-items: center;
  grid-template-columns: auto;
  grid-template-rows: 30px auto;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  width: ${(props) => (props.width ? props.width : 'min(520px, 92vw)')};
`;

export const WrapperTitle = styled.div`
  font-size: clamp(24px, 4.5vw, 36px);
  padding-top: 50px;
  padding-bottom: 40px;
  font-weight: 900;
`;

export const Wrapper = styled.div`
  align-items: flex-start;
  justify-content: center;
  ${(props) => props.input && 'margin: 10px 0'}
`;

export const ErrorMessage = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.red};
`;

export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px',
    width: '90%',
    height: '90%',
  },
};

export const WrapperAdornment = styled.div`
  background-color: red;
  padding-left: 100px;
`;
